export const GET_DATA = 'GET_DATA';
export const UPDATE_TAG = 'UPDATE_TAG';
export const UPDATE_SORTBY = 'UPDATE_SORTBY';
export const UPDATE_UPVOTE = 'UPDATE_UPVOTE';
export const CHANGE_SUGGCLICKED = 'CHANGE_SUGGCLICKED';
export const ADD_COMMENT = 'ADD_COMMENT';
export const SET_ACTIVEREQ = 'SET_ACTIVEREQ';
export const COMMENTS_COUNT = 'COMMENTS_COUNT';
export const ADD_REPLY = 'ADD_REPLY';
export const ADD_FEEDBACK = 'ADD_FEEDBACK';
export const DELETE_FEEDBACK = 'DELETE_FEEDBACK';
export const EDIT_FEEDBACK = 'EDIT_FEEDBACK';
